module.exports = __webpack_public_path__ + "static/media/reports_withdrawal-record.86d91ee7.svg";